import { render, staticRenderFns } from "./GateOtherDamages.vue?vue&type=template&id=28353606&scoped=true"
import script from "./GateOtherDamages.vue?vue&type=script&lang=ts"
export * from "./GateOtherDamages.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28353606",
  null
  
)

export default component.exports